import BaseApi from "./BaseApi";
import axios from "axios";

class CandidateApplicationApi extends BaseApi {
  constructor() {
    super("candidate-applications");
  }

  getScreeningQuestions(id) {
    return axios.get(`${this.baseUrl}/${id}/screening-questions`);
  }

  getFullApplications(params = null) {
    return axios.get(`${this.baseUrl}/full`, { params });
  }
}

export default CandidateApplicationApi;
